// extracted by mini-css-extract-plugin
export default {"gao2_two":"Search_gao2_two__zEls2","jiga2_three":"Search_jiga2_three__swkvo"};